export default __webpack_public_path__ + "static/CogniTraxHowItWorksCokeBottleDemo-0e0a685ad85e71a544d6a0dca71a06be.gif";